<div class="grid xl:w-12 w-full pt-4">
    @if(tenant && tenant.firm && 
        (tenant.firm.isSingleJobTypeEnabled && !tenant.firm.isSingleSearchMarketEnabled ||
        !tenant.firm.isSingleJobTypeEnabled && tenant.firm.isSingleSearchMarketEnabled ||
        !tenant.firm.isSingleJobTypeEnabled && !tenant.firm.isSingleSearchMarketEnabled)){
        <div class="lg:col-6 col-12">
            <ul class="list-none h-100 w-100 flex flex-column gap-3 p-3 m-0 p-0 wrap-edit-dashboard simple-ui" [class.gradient-ul]="!isPWCEnabled && isMobile" >
                <li class="main-profile-item cursor-pointer py-5 px-6 border-round-md text-xl font-bold uppercase flex flex-grow-1 align-items-center flex-nowrap card-body" (click)="goto('/reviewer/profile/general')">
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-psychology-profile-outlined"></span>
                    <span class="left-margin">General</span>
                </li>
            </ul>
        </div>
    }

    <div class="lg:col-6 col-12">
        <ul class="list-none h-100 w-100 flex flex-column gap-3 p-3 m-0 p-0 wrap-edit-dashboard simple-ui" [class.gradient-ul]="!isPWCEnabled && isMobile" >
            <li class=" main-profile-item cursor-pointer py-5 px-6 border-round-md text-xl font-bold uppercase flex flex-grow-1 align-items-center flex-nowrap card-body" (click)="goto('/reviewer/profile/education')">
                <span class="{{helperService.getEnvironmentName()}}-icon icon-school-outlined"></span>
                <span class="left-margin">Education</span>
                @if(tenant?.firm?.isEducationRequired && !tenant?.strength?.education){
                    <span class="material-symbols-outlined incomplete-icon red">error</span>
                }
            </li>
        </ul>
    </div>

    <div class="lg:col-6 col-12">
        <ul class="list-none h-100 w-100 flex flex-column gap-3 p-3 m-0 p-0 wrap-edit-dashboard simple-ui" [class.gradient-ul]="!isPWCEnabled && isMobile">
            <li class=" main-profile-item cursor-pointer py-5 px-6 border-round-md text-xl font-bold uppercase flex flex-grow-1 align-items-center flex-nowrap card-body" (click)="goto('/reviewer/profile/resume')">
                <span class="{{helperService.getEnvironmentName()}}-icon icon-file-present-outlined"></span>
                <span class="left-margin">{{'Resume & Certifications' | sentenceCase}}</span>
                @if(!(tenant?.strength?.document)){
                    <span [pTooltip]="'Please upload Resume' | sentenceCase" tooltipPosition="top" icon="true"
                        class="{{helperService.getEnvironmentName()}}-icon icon-info-outlined red ml-2"></span>
                }
            </li>
        </ul>
    </div>

    @if(credentials && credentials.length){
        <div class="lg:col-6 col-12">
            <ul class="list-none h-100 w-100 flex flex-column gap-3 p-3 m-0 p-0 wrap-edit-dashboard simple-ui" [class.gradient-ul]="!isPWCEnabled && isMobile">
                <li class=" main-profile-item cursor-pointer py-5 px-6 border-round-md text-xl font-bold uppercase flex flex-grow-1 align-items-center flex-nowrap card-body" (click)="goto('/reviewer/profile/credentials')">
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-password-outlined"></span>
                    <span class="left-margin">Credentials</span>
                    @if(!(tenant?.strength?.credentials)){
                        <span [pTooltip]="'Please add Credentials' | sentenceCase" tooltipPosition="top" icon="true"
                        class="{{helperService.getEnvironmentName()}}-icon icon-info-outlined red ml-2"></span>
                    }
                </li>
            </ul>
        </div>
    }

    @if(skillsAndExperience && skillsAndExperience.length){
        <div class="lg:col-6 col-12">
            <ul class="list-none h-100 w-100 flex flex-column gap-3 p-3 m-0 p-0 wrap-edit-dashboard simple-ui" [class.gradient-ul]="!isPWCEnabled && isMobile">
                <li class=" main-profile-item cursor-pointer py-5 px-6 border-round-md text-xl font-bold uppercase flex flex-grow-1 align-items-center flex-nowrap card-body" (click)="goto('/reviewer/profile/skills')">
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-settings-accessibility-outlined"></span>
                    <span class="left-margin">Skills & Experience</span>
                    @if(!(tenant?.strength?.skill)){
                        <span [pTooltip]="'Please add Skills & Experience' | sentenceCase" tooltipPosition="top" icon="true"
                        class="{{helperService.getEnvironmentName()}}-icon icon-info-outlined red ml-2"></span>
                    }
                </li>
            </ul>
        </div>
    }
</div>
